const NATURAL_FEED_SCROLL_SETTLE_MS = 180

const activeScrollTokens = new Set<symbol>()
const settleHandles = new Map<symbol, number>()
const activityListeners = new Set<() => void>()

function notifyActivityListeners() {
    activityListeners.forEach(listener => listener())
}

export function subscribeNaturalFeedScrollActivity(listener: () => void) {
    activityListeners.add(listener)
    return () => {
        activityListeners.delete(listener)
    }
}

export function markNaturalFeedScrollActive(
    token: symbol,
    event?: Event,
    targetWindow: Window = window,
) {
    const wasGloballyActive = activeScrollTokens.size > 0
    activeScrollTokens.add(token)
    if (!wasGloballyActive) notifyActivityListeners()
    const previousHandle = settleHandles.get(token)
    if (previousHandle != null) targetWindow.clearTimeout(previousHandle)

    // Native `scrollend` is an optimization, not the sole settlement path. Chromium can
    // miss it during navigation or DOM replacement, which previously left stream cards
    // permanently gated behind their geometry placeholder.
    settleHandles.set(
        token,
        targetWindow.setTimeout(
            () => markNaturalFeedScrollIdle(token, targetWindow),
            NATURAL_FEED_SCROLL_SETTLE_MS,
        ),
    )
}

export function markNaturalFeedScrollIdle(token: symbol, targetWindow: Window = window) {
    const wasGloballyActive = activeScrollTokens.size > 0
    const settleHandle = settleHandles.get(token)
    if (settleHandle != null) targetWindow.clearTimeout(settleHandle)
    settleHandles.delete(token)
    activeScrollTokens.delete(token)
    if (wasGloballyActive && activeScrollTokens.size === 0) notifyActivityListeners()
}

export function naturalFeedScrollIsActive() {
    return activeScrollTokens.size > 0
}
